import React, { useState, useEffect } from 'react';
import EvaluationButton from './EvaluationButton';
import { FORM_FIELD } from '../../../ui/formTheme';

const EvaluationSignatureModal = ({ 
    isOpen, 
    onClose, 
    onSign, 
    title = "Electronic Signature", 
    description = "Type your full name to sign this document legally.",
    placeholder = "Full Name",
    signButtonText = "Sign Document",
    children,
    disableSign = false
}) => {
    const [name, setName] = useState("");

    useEffect(() => {
        if (isOpen) {
            setName("");
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-slate-900/40 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl border border-indigo-200 shadow-xl p-6 max-w-md w-full">
                <h3 className="text-lg font-semibold text-slate-900 mb-1">{title}</h3>
                <p className="text-sm text-slate-500 mb-6">{description}</p>
                
                {children ? (
                    <div className="mb-6">
                        {children}
                    </div>
                ) : (
                    <div className="mb-6">
                        <label className={FORM_FIELD.label}>
                            Your Name
                        </label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className={`${FORM_FIELD.control} ${FORM_FIELD.enabled}`}
                            placeholder={placeholder}
                            autoFocus
                        />
                    </div>
                )}

                <div className="flex gap-3 justify-end">
                    <EvaluationButton 
                        variant="secondary" 
                        onClick={onClose}
                        className="px-6 py-2"
                    >
                        Cancel
                    </EvaluationButton>
                    <EvaluationButton
                        onClick={() => onSign(name)}
                        disabled={disableSign || (!children && !name.trim())}
                        className="px-6 py-2"
                    >
                        {signButtonText}
                    </EvaluationButton>
                </div>
            </div>
        </div>
    );
};

export default EvaluationSignatureModal;
